import React from 'react';
import GlobalNav from './GlobalNav';

// Sticky Header wrapper that keeps the navigation visible while scrolling
const StickyHeader = () => {
  return (
    <header 
      className="sticky top-0 z-[1000] w-full"
      data-testid="sticky-header"
    >
      {/* Spacer/background for the sticky header */}
      <div className="bg-gradient-to-b from-slate-50 to-transparent pt-4 pb-2">
        <div className="container mx-auto px-4 md:px-8">
          <GlobalNav />
        </div>
      </div>
    </header>
  );
};

export default StickyHeader;
